import { centralizedAuth } from '@cimpress/simple-auth-wrapper';

import { commonConstant } from '../constants';

const auth = new centralizedAuth({
  clientID: commonConstant.EM_CLIENT_ID,
});

export default auth;
